import {
  CREATE_QUEUE_RECORD,
  CREATE_QUEUE_RECORD_SUCCESS,
  CREATE_QUEUE_RECORD_FAILURE,
  UPDATE_QUEUE_RECORD,
  UPDATE_QUEUE_RECORD_SUCCESS,
  UPDATE_QUEUE_RECORD_FAILURE,
  DELETE_QUEUE_RECORD,
  DELETE_QUEUE_RECORD_SUCCESS,
  DELETE_QUEUE_RECORD_FAILURE,
  GET_QUEUE_RECORD,
  GET_QUEUE_RECORD_SUCCESS,
  GET_QUEUE_RECORD_FAILURE,
  LIST_QUEUE_RECORDS,
  LIST_QUEUE_RECORDS_SUCCESS,
  LIST_QUEUE_RECORDS_FAILURE,
} from "../actions/queueServicesActions";

const initialState = {
  queueRecords: [], // List of all queue records
  currentQueueRecord: null, // Currently selected queue record
  queueRecordsConnection: null, // Pagination connection for list results
  loading: false, // Loading state
  error: null, // Error state
};

const queueServicesReducer = (state = initialState, action) => {
  console.log("queueServicesReducer received action:", action.type, action);

  switch (action.type) {
    // Loading states
    case CREATE_QUEUE_RECORD:
      console.log(
        "Processing CREATE_QUEUE_RECORD action with payload:",
        action.payload
      );
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_QUEUE_RECORD:
    case DELETE_QUEUE_RECORD:
    case GET_QUEUE_RECORD:
    case LIST_QUEUE_RECORDS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    // Success states
    case CREATE_QUEUE_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
        // Add the new queue record to the list if creation was successful
        queueRecords: action.payload.success
          ? [...state.queueRecords, action.payload]
          : state.queueRecords,
        currentQueueRecord: action.payload.success ? action.payload : null,
        error: null,
      };

    case UPDATE_QUEUE_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
        // Update the queue record in the list if update was successful
        queueRecords: action.payload.success
          ? state.queueRecords.map((record) =>
              record.id === action.payload.id ? action.payload : record
            )
          : state.queueRecords,
        currentQueueRecord: action.payload.success
          ? action.payload
          : state.currentQueueRecord,
        error: null,
      };

    case DELETE_QUEUE_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
        // Remove the queue record from the list if deletion was successful
        queueRecords: action.payload.success
          ? state.queueRecords.filter(
              (record) => record.id !== action.payload.id
            )
          : state.queueRecords,
        currentQueueRecord: action.payload.success
          ? null
          : state.currentQueueRecord,
        error: null,
      };

    case GET_QUEUE_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentQueueRecord: action.payload,
        error: null,
      };

    case LIST_QUEUE_RECORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        queueRecordsConnection: action.payload,
        // Update the queue records list with the new messages
        queueRecords: action.payload.messages || [],
        error: null,
      };

    // Failure states
    case CREATE_QUEUE_RECORD_FAILURE:
    case UPDATE_QUEUE_RECORD_FAILURE:
    case DELETE_QUEUE_RECORD_FAILURE:
    case GET_QUEUE_RECORD_FAILURE:
    case LIST_QUEUE_RECORDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default queueServicesReducer;
